module.exports = __webpack_public_path__ + "img/login-icon.bb32fd20.png";